<template>
<div>
	<img class="wave" src="img/wave.png">
	<div class="container1">
		<div class="img">
			<img src="img/bg.svg">
		</div>
		<div class="login-content">
			<form action="" class="form1">
				<img src="img/avatar.svg">
				<h2 class="title">Welcome</h2>
                <base-input class="input-login" addon-left-icon="tim-icons icon-email-85"
                            type="email"
                            placeholder="Enter email"
                            v-model="username"
                            >
                </base-input>

           		<base-input 
                  class="input-login"
                  addon-left-icon="tim-icons icon-lock-circle"
                  type="password"
                  placeholder="Password"
                  v-model="password"
                  >
                </base-input>
            	<a href="#">Forgot Password?</a>
            	<base-button class="btn1" v-on:click="login" type="default">Submit</base-button>
            </form>
        </div>
    </div>

</div>
<!--
<card>
    <form @submit.prevent>
      <base-input label="Email address"
                  type="email"
                  placeholder="Enter email"
                  v-model="username"
                  >
      </base-input>
      <base-input label="Password"
                  type="password"
                  placeholder="Password"
                  v-model="password"
                  >
      </base-input>
      <base-checkbox>
        Option one is this 
     </base-checkbox>
     <base-button v-on:click="login" type="primary">Submit</base-button>
    </form>
</card>
 -->
</template>

<script>
    export default {
        name: 'login'
    }
</script>
<script>
import axios from 'axios'
import { loginUser } from '../utils/auth'


export default {
    name: 'login',
    data() {
        return {
            username: '',
            password: ''
        }
    },
    methods: {
        async login() {
            try {
                await loginUser(this.username, this.password)
                this.$router.push('/')
            }
            catch (err) {
                alert(`Error: ${err}`)
            }

        }
    }
}
</script>

<style>

.input-login{
    margin-left: 1px;
}


.wave{
	position: fixed;
	bottom: 0;
	left: 0;
	height: 100%;
	z-index: -1;
}

.container1{
    width: 100vw;
    height: 100vh;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap :7rem;
    padding: 0 2rem;
}

.img{
	display: flex;
	justify-content: flex-end;
	align-items: center;
}

.login-content{
	display: flex;
	justify-content: flex-start;
	align-items: center;
	text-align: center;
}

.img img{
	width: 500px;
}

.form1{
	width: 360px;
}

.login-content img{
    height: 100px;
}


.btn1{
	display: block;
	width: 100%;
	height: 50px;
	border-radius: 25px;
	outline: none;
	border: none;
	background-image: linear-gradient(to right, #32be8f, #38d39f, #32be8f);
	background-size: 200%;
	font-size: 1.2rem;
	color: #fff;
	font-family: 'Poppins', sans-serif;
	text-transform: uppercase;
	margin: 1rem 0;
	cursor: pointer;
	transition: .5s;
}



@media screen and (max-width: 1050px){
	.container1{
		grid-gap: 5rem;
	}
}

@media screen and (max-width: 1000px){
	.form1{
		width: 290px;
	}

	.login-content h2{
        font-size: 2.4rem;
        margin: 8px 0;
	}

	.img img{
		width: 400px;
	}
}

@media screen and (max-width: 900px){
	.container1{
		grid-template-columns: 1fr;
	}

	.img{
		display: none;
	}

	.wave{
		display: none;
	}

	.login-content{
		justify-content: center;
	}
}
</style>